import { useEffect, useState } from 'react';
import { useBusiness } from '../contexts/BusinessContext';
import {
  ensurePayrollHoursLabels,
  normalizePayrollMinutes,
  peekPayrollHoursLabel,
  subscribePayrollHoursLabelReset,
} from '../lib/payrollHoursLabel';

/** Print worked minutes using the business payroll setting. The text comes from Postgres. */
export function usePayrollHoursText(minutes: number[]): (value: number) => string {
  const { selectedBusiness } = useBusiness();
  const businessId = selectedBusiness?.id ?? null;
  const [tick, setTick] = useState(0);
  const key = minutes.map((value) => normalizePayrollMinutes(value)).sort((a, b) => a - b).join(',');

  useEffect(() => {
    if (!businessId) return;
    let cancelled = false;
    const requested = key.length > 0 ? key.split(',').map((part) => Number(part)) : [0];
    const load = () => {
      void ensurePayrollHoursLabels(businessId, requested).then(() => {
        if (!cancelled) setTick((value) => value + 1);
      });
    };
    load();
    const unsubscribe = subscribePayrollHoursLabelReset(load);
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [businessId, key]);

  return (value: number) => {
    void tick;
    if (!businessId) return '';
    return peekPayrollHoursLabel(businessId, value) ?? '';
  };
}
